/* @flow */

export type StoreType = {
  name: string,
  logoSmallWidth?: number,
  logoSmall?: string,
  logoSmall2x?: string,
  logoLargeWidth?: number,
  logoLarge?: string,
  logoLarge2x?: string,
  background: string,
  background2x: string,
  brandColor: string,
  description: string,
  metaDescription: string,
};

function makeDescription(storeName: string) {
  return `Same day ${storeName} delivery in under an hour. Get on-demand movers and a truck to pickup and deliver from your nearest ${storeName}. Get an estimate and try it today!`;
}

function makeMetaDescription(storeName: string) {
  return `Same day ${storeName} delivery in under an hour. Learn how to get on-demand movers and a truck to pickup and deliver from your nearest ${storeName}. Get an estimate and try it today!`;
}

const STORES: { [id: string]: StoreType } = {
  'world-market': {
    name: 'World Market',
    logoSmallWidth: 160,
    logoSmall: require('../assets/images/logos/world-market-small.png'),
    logoSmall2x: require('../assets/images/logos/world-market-small_2x.png'),
    logoLargeWidth: 400,
    logoLarge: require('../assets/images/logos/world-market-large.png'),
    logoLarge2x: require('../assets/images/logos/world-market-large_2x.png'),
    logoSquareWidth: 120,
    logoSquare: require('../assets/images/logos/world-market-square.png'),
    logoSquare2x: require('../assets/images/logos/world-market-small_2x.png'),
    background: require('../assets/images/header-photos/world-market.jpg'),
    background2x: require('../assets/images/header-photos/world-market_2x.jpg'),
    brandColor: '#BF311B',
    get description() {
      return makeDescription(this.name);
    },
    get metaDescription() {
      return makeMetaDescription(this.name);
    },
  },
  costco: {
    name: 'Costco',
    logoSmallWidth: 160,
    logoSmall: require('../assets/images/logos/costco-small.png'),
    logoSmall2x: require('../assets/images/logos/costco-small_2x.png'),
    logoLargeWidth: 347,
    logoLarge: require('../assets/images/logos/costco-large.png'),
    logoLarge2x: require('../assets/images/logos/costco-large_2x.png'),
    logoSquareWidth: 120,
    logoSquare: require('../assets/images/logos/costco-square.png'),
    logoSquare2x: require('../assets/images/logos/costco-square_2x.png'),
    background: require('../assets/images/header-photos/costco.jpg'),
    background2x: require('../assets/images/header-photos/costco_2x.jpg'),
    brandColor: '#0060A9',
    get description() {
      return makeDescription(this.name);
    },
    get metaDescription() {
      return makeMetaDescription(this.name);
    },
  },
  'crate-and-barrel': {
    name: 'Crate and Barrel',
    logoSmallWidth: 160,
    logoSmall: require('../assets/images/logos/crate-and-barrel-small.png'),
    logoSmall2x: require('../assets/images/logos/crate-and-barrel-small_2x.png'),
    logoLargeWidth: 422,
    logoLarge: require('../assets/images/logos/crate-and-barrel-large.png'),
    logoLarge2x: require('../assets/images/logos/crate-and-barrel-large_2x.png'),
    logoSquareWidth: 120,
    logoSquare: require('../assets/images/logos/crate-and-barrel-square.png'),
    logoSquare2x: require('../assets/images/logos/crate-and-barrel-square_2x.png'),
    background: require('../assets/images/header-photos/crate-and-barrel.jpg'),
    background2x: require('../assets/images/header-photos/crate-and-barrel_2x.jpg'),
    brandColor: '#231F20',
    get description() {
      return makeDescription(this.name);
    },
    get metaDescription() {
      return makeMetaDescription(this.name);
    },
  },
  'pottery-barn': {
    name: 'Pottery Barn',
    logoSmallWidth: 140,
    logoSmall: require('../assets/images/logos/pottery-barn-small.png'),
    logoSmall2x: require('../assets/images/logos/pottery-barn-small_2x.png'),
    logoLargeWidth: 285,
    logoLarge: require('../assets/images/logos/pottery-barn-large.png'),
    logoLarge2x: require('../assets/images/logos/pottery-barn-large_2x.png'),
    logoSquareWidth: 120,
    logoSquare: require('../assets/images/logos/pottery-barn-square.png'),
    logoSquare2x: require('../assets/images/logos/pottery-barn-square_2x.png'),
    background: require('../assets/images/header-photos/pottery-barn.jpg'),
    background2x: require('../assets/images/header-photos/pottery-barn_2x.jpg'),
    brandColor: '#231F20',
    get description() {
      return makeDescription(this.name);
    },
    get metaDescription() {
      return makeMetaDescription(this.name);
    },
  },
  'restoration-hardware': {
    name: 'Restoration Hardware',
    logoSmallWidth: 120,
    logoSmall: require('../assets/images/logos/restoration-hardware-small.png'),
    logoSmall2x: require('../assets/images/logos/restoration-hardware-small_2x.png'),
    logoLargeWidth: 176,
    logoLarge: require('../assets/images/logos/restoration-hardware-large.png'),
    logoLarge2x: require('../assets/images/logos/restoration-hardware-large_2x.png'),
    logoSquareWidth: 120,
    logoSquare: require('../assets/images/logos/restoration-hardware-square.png'),
    logoSquare2x: require('../assets/images/logos/restoration-hardware-square_2x.png'),
    background: require('../assets/images/header-photos/restoration-hardware.jpg'),
    background2x: require('../assets/images/header-photos/restoration-hardware_2x.jpg'),
    brandColor: '#444444',
    get description() {
      return makeDescription(this.name);
    },
    get metaDescription() {
      return makeMetaDescription(this.name);
    },
  },
  'west-elm': {
    name: 'West Elm',
    logoSmallWidth: 160,
    logoSmall: require('../assets/images/logos/west-elm-small.png'),
    logoSmall2x: require('../assets/images/logos/west-elm-small_2x.png'),
    logoLargeWidth: 488,
    logoLarge: require('../assets/images/logos/west-elm-large.png'),
    logoLarge2x: require('../assets/images/logos/west-elm-large_2x.png'),
    logoSquareWidth: 120,
    logoSquare: require('../assets/images/logos/west-elm-square.png'),
    logoSquare2x: require('../assets/images/logos/west-elm-square_2x.png'),
    background: require('../assets/images/header-photos/west-elm.jpg'),
    background2x: require('../assets/images/header-photos/west-elm_2x.jpg'),
    brandColor: '#565656',
    get description() {
      return makeDescription(this.name);
    },
    get metaDescription() {
      return makeMetaDescription(this.name);
    },
  },
  lowes: {
    name: 'Lowes',
    logoSmallWidth: 160,
    logoSmall: require('../assets/images/logos/lowes-small.png'),
    logoSmall2x: require('../assets/images/logos/lowes-small_2x.png'),
    logoLargeWidth: 217,
    logoLarge: require('../assets/images/logos/lowes-large.png'),
    logoLarge2x: require('../assets/images/logos/lowes-large_2x.png'),
    logoSquareWidth: 120,
    logoSquare: require('../assets/images/logos/lowes-square.png'),
    logoSquare2x: require('../assets/images/logos/lowes-square_2x.png'),
    background: require('../assets/images/header-photos/lowes.jpg'),
    background2x: require('../assets/images/header-photos/lowes_2x.jpg'),
    brandColor: '#004890',
    get description() {
      return makeDescription(this.name);
    },
    get metaDescription() {
      return makeMetaDescription(this.name);
    },
  },
  'ashley-furniture': {
    name: 'Ashley Furniture',
    logoSmallWidth: 160,
    logoSmall: require('../assets/images/logos/ashley-furniture-small.png'),
    logoSmall2x: require('../assets/images/logos/ashley-furniture-small_2x.png'),
    logoLargeWidth: 367,
    logoLarge: require('../assets/images/logos/ashley-furniture-large.png'),
    logoLarge2x: require('../assets/images/logos/ashley-furniture-large_2x.png'),
    logoSquareWidth: 120,
    logoSquare: require('../assets/images/logos/ashley-furniture-square.png'),
    logoSquare2x: require('../assets/images/logos/ashley-furniture-square_2x.png'),
    background: require('../assets/images/header-photos/ashley-furniture.jpg'),
    background2x: require('../assets/images/header-photos/ashley-furniture_2x.jpg'),
    brandColor: '#3E3934',
    get description() {
      return makeDescription(this.name);
    },
    get metaDescription() {
      return makeMetaDescription(this.name);
    },
  },
  'best-buy': {
    name: 'Best Buy',
    logoSmallWidth: 120,
    logoSmall: require('../assets/images/logos/best-buy-small.png'),
    logoSmall2x: require('../assets/images/logos/best-buy-small_2x.png'),
    logoLargeWidth: 175,
    logoLarge: require('../assets/images/logos/best-buy-large.png'),
    logoLarge2x: require('../assets/images/logos/best-buy-large_2x.png'),
    logoSquareWidth: 120,
    logoSquare: require('../assets/images/logos/best-buy-square.png'),
    logoSquare2x: require('../assets/images/logos/best-buy-square_2x.png'),
    background: require('../assets/images/header-photos/best-buy.jpg'),
    background2x: require('../assets/images/header-photos/best-buy_2x.jpg'),
    brandColor: '#3B538F',
    get description() {
      return makeDescription(this.name);
    },
    get metaDescription() {
      return makeMetaDescription(this.name);
    },
  },
  cb2: {
    name: 'CB2',
    logoSmallWidth: 140,
    logoSmall: require('../assets/images/logos/cb2-small.png'),
    logoSmall2x: require('../assets/images/logos/cb2-small_2x.png'),
    logoLargeWidth: 221,
    logoLarge: require('../assets/images/logos/cb2-large.png'),
    logoLarge2x: require('../assets/images/logos/cb2-large_2x.png'),
    logoSquareWidth: 120,
    logoSquare: require('../assets/images/logos/cb2-square.png'),
    logoSquare2x: require('../assets/images/logos/cb2-square_2x.png'),
    background: require('../assets/images/header-photos/cb2.jpg'),
    background2x: require('../assets/images/header-photos/cb2_2x.jpg'),
    brandColor: '#505052',
    get description() {
      return makeDescription(this.name);
    },
    get metaDescription() {
      return makeMetaDescription(this.name);
    },
  },
  'cort-furniture': {
    name: 'Cort Furniture',
    logoSmallWidth: 140,
    logoSmall: require('../assets/images/logos/cort-furniture-small.png'),
    logoSmall2x: require('../assets/images/logos/cort-furniture-small_2x.png'),
    logoLargeWidth: 431,
    logoLarge: require('../assets/images/logos/cort-furniture-large.png'),
    logoLarge2x: require('../assets/images/logos/cort-furniture-large_2x.png'),
    logoSquareWidth: 120,
    logoSquare: require('../assets/images/logos/cort-furniture-square.png'),
    logoSquare2x: require('../assets/images/logos/cort-furniture-square_2x.png'),
    background: require('../assets/images/header-photos/cort-furniture.jpg'),
    background2x: require('../assets/images/header-photos/cort-furniture_2x.jpg'),
    brandColor: '#eb3337',
    get description() {
      return makeDescription(this.name);
    },
    get metaDescription() {
      return makeMetaDescription(this.name);
    },
  },
  'design-within-reach': {
    name: 'Design Within Reach',
    logoSmallWidth: 140,
    logoSmall: require('../assets/images/logos/design-within-reach-small.png'),
    logoSmall2x: require('../assets/images/logos/design-within-reach-small_2x.png'),
    logoLargeWidth: 189,
    logoLarge: require('../assets/images/logos/design-within-reach-large.png'),
    logoLarge2x: require('../assets/images/logos/design-within-reach-large_2x.png'),
    logoSquareWidth: 120,
    logoSquare: require('../assets/images/logos/design-within-reach-square.png'),
    logoSquare2x: require('../assets/images/logos/design-within-reach-square_2x.png'),
    background: require('../assets/images/header-photos/design-within-reach.jpg'),
    background2x: require('../assets/images/header-photos/design-within-reach_2x.jpg'),
    brandColor: '#ED1F28',
    get description() {
      return makeDescription(this.name);
    },
    get metaDescription() {
      return makeMetaDescription(this.name);
    },
  },
  eq3: {
    name: 'EQ3',
    logoSmallWidth: 140,
    logoSmall: require('../assets/images/logos/eq3-small.png'),
    logoSmall2x: require('../assets/images/logos/eq3-small_2x.png'),
    logoLargeWidth: 231,
    logoLarge: require('../assets/images/logos/eq3-large.png'),
    logoLarge2x: require('../assets/images/logos/eq3-large_2x.png'),
    logoSquareWidth: 120,
    logoSquare: require('../assets/images/logos/eq3-square.png'),
    logoSquare2x: require('../assets/images/logos/eq3-square_2x.png'),
    background: require('../assets/images/header-photos/eq3.jpg'),
    background2x: require('../assets/images/header-photos/eq3_2x.jpg'),
    brandColor: '#BD1F35',
    get description() {
      return makeDescription(this.name);
    },
    get metaDescription() {
      return makeMetaDescription(this.name);
    },
  },
  'home-depot': {
    name: 'The Home Depot',
    logoSmallWidth: 100,
    logoSmall: require('../assets/images/logos/home-depot-small.png'),
    logoSmall2x: require('../assets/images/logos/home-depot-small_2x.png'),
    logoLargeWidth: 121,
    logoLarge: require('../assets/images/logos/home-depot-large.png'),
    logoLarge2x: require('../assets/images/logos/home-depot-large_2x.png'),
    logoSquareWidth: 120,
    logoSquare: require('../assets/images/logos/home-depot-square.png'),
    logoSquare2x: require('../assets/images/logos/home-depot-square_2x.png'),
    background: require('../assets/images/header-photos/home-depot.jpg'),
    background2x: require('../assets/images/header-photos/home-depot_2x.jpg'),
    brandColor: '#EE7125',
    get description() {
      return makeDescription(this.name);
    },
    get metaDescription() {
      return makeMetaDescription(this.name);
    },
  },
  'living-spaces': {
    name: 'Living Spaces',
    logoSmallWidth: 113,
    logoSmall: require('../assets/images/logos/living-spaces-small.png'),
    logoSmall2x: require('../assets/images/logos/living-spaces-small_2x.png'),
    logoLargeWidth: 169,
    logoLarge: require('../assets/images/logos/living-spaces-large.png'),
    logoLarge2x: require('../assets/images/logos/living-spaces-large_2x.png'),
    logoSquareWidth: 120,
    logoSquare: require('../assets/images/logos/living-spaces-square.png'),
    logoSquare2x: require('../assets/images/logos/living-spaces-square_2x.png'),
    background: require('../assets/images/header-photos/living-spaces.jpg'),
    background2x: require('../assets/images/header-photos/living-spaces_2x.jpg'),
    brandColor: '#515348',
    get description() {
      return makeDescription(this.name);
    },
    get metaDescription() {
      return makeMetaDescription(this.name);
    },
  },
  'z-gallerie': {
    name: 'Z Gallerie',
    logoSmallWidth: 150,
    logoSmall: require('../assets/images/logos/z-gallerie-small.png'),
    logoSmall2x: require('../assets/images/logos/z-gallerie-small_2x.png'),
    logoLargeWidth: 464,
    logoLarge: require('../assets/images/logos/z-gallerie-large.png'),
    logoLarge2x: require('../assets/images/logos/z-gallerie-large_2x.png'),
    logoSquareWidth: 120,
    logoSquare: require('../assets/images/logos/z-gallerie-square.png'),
    logoSquare2x: require('../assets/images/logos/z-gallerie-square_2x.png'),
    background: require('../assets/images/header-photos/z-gallerie.jpg'),
    background2x: require('../assets/images/header-photos/z-gallerie_2x.jpg'),
    brandColor: '#221E20',
    get description() {
      return makeDescription(this.name);
    },
    get metaDescription() {
      return makeMetaDescription(this.name);
    },
  },
  'ana-furniture': {
    name: 'Ana Furniture',
    logoSmallWidth: 157,
    logoSmall: require('../assets/images/logos/ana-furniture-small.png'),
    logoSmall2x: require('../assets/images/logos/ana-furniture-small_2x.png'),
    logoLargeWidth: 333,
    logoLarge: require('../assets/images/logos/ana-furniture-large.png'),
    logoLarge2x: require('../assets/images/logos/ana-furniture-large_2x.png'),
    logoSquareWidth: 120,
    logoSquare: require('../assets/images/logos/ana-furniture-square.png'),
    logoSquare2x: require('../assets/images/logos/ana-furniture-square_2x.png'),
    background: require('../assets/images/header-photos/ana-furniture.jpg'),
    background2x: require('../assets/images/header-photos/ana-furniture_2x.jpg'),
    brandColor: '#000',
    get description() {
      return makeDescription(this.name);
    },
    get metaDescription() {
      return makeMetaDescription(this.name);
    },
  },
  anthropologie: {
    name: 'Anthropologie',
    logoSmallWidth: 160,
    logoSmall: require('../assets/images/logos/anthropologie-small.png'),
    logoSmall2x: require('../assets/images/logos/anthropologie-small_2x.png'),
    logoLargeWidth: 640,
    logoLarge: require('../assets/images/logos/anthropologie-large.png'),
    logoLarge2x: require('../assets/images/logos/anthropologie-large_2x.png'),
    logoSquareWidth: 120,
    logoSquare: require('../assets/images/logos/anthropologie-square.png'),
    logoSquare2x: require('../assets/images/logos/anthropologie-square_2x.png'),
    background: require('../assets/images/header-photos/anthropologie.jpg'),
    background2x: require('../assets/images/header-photos/anthropologie_2x.jpg'),
    brandColor: '#000',
    get description() {
      return makeDescription(this.name);
    },
    get metaDescription() {
      return makeMetaDescription(this.name);
    },
  },
  'ethan-allen': {
    name: 'Ethan Allen',
    logoSmallWidth: 160,
    logoSmall: require('../assets/images/logos/ethan-allen-small.png'),
    logoSmall2x: require('../assets/images/logos/ethan-allen-small_2x.png'),
    logoLargeWidth: 640,
    logoLarge: require('../assets/images/logos/ethan-allen-large.png'),
    logoLarge2x: require('../assets/images/logos/ethan-allen-large_2x.png'),
    logoSquareWidth: 120,
    logoSquare: require('../assets/images/logos/ethan-allen-square.png'),
    logoSquare2x: require('../assets/images/logos/ethan-allen-square_2x.png'),
    background: require('../assets/images/header-photos/ethan-allen.jpg'),
    background2x: require('../assets/images/header-photos/ethan-allen_2x.jpg'),
    brandColor: '#231F20',
    get description() {
      return makeDescription(this.name);
    },
    get metaDescription() {
      return makeMetaDescription(this.name);
    },
  },
  'hd-buttercup': {
    name: 'HD Buttercup',
    logoSmallWidth: 160,
    logoSmall: require('../assets/images/logos/hd-buttercup-small.png'),
    logoSmall2x: require('../assets/images/logos/hd-buttercup-small_2x.png'),
    logoLargeWidth: 377,
    logoLarge: require('../assets/images/logos/hd-buttercup-large.png'),
    logoLarge2x: require('../assets/images/logos/hd-buttercup-large_2x.png'),
    logoSquareWidth: 120,
    logoSquare: require('../assets/images/logos/hd-buttercup-square.png'),
    logoSquare2x: require('../assets/images/logos/hd-buttercup-square_2x.png'),
    background: require('../assets/images/header-photos/hd-buttercup.jpg'),
    background2x: require('../assets/images/header-photos/hd-buttercup_2x.jpg'),
    brandColor: '#EA2876',
    get description() {
      return makeDescription(this.name);
    },
    get metaDescription() {
      return makeMetaDescription(this.name);
    },
  },
  'lamps-plus': {
    name: 'Lamps Plus',
    logoSmallWidth: 159,
    logoSmall: require('../assets/images/logos/lamps-plus-small.png'),
    logoSmall2x: require('../assets/images/logos/lamps-plus-small_2x.png'),
    logoLargeWidth: 638,
    logoLarge: require('../assets/images/logos/lamps-plus-large.png'),
    logoLarge2x: require('../assets/images/logos/lamps-plus-large_2x.png'),
    logoSquareWidth: 120,
    logoSquare: require('../assets/images/logos/lamps-plus-square.png'),
    logoSquare2x: require('../assets/images/logos/lamps-plus-square_2x.png'),
    background: require('../assets/images/header-photos/lamps-plus.jpg'),
    background2x: require('../assets/images/header-photos/lamps-plus_2x.jpg'),
    brandColor: '#CC0001',
    get description() {
      return makeDescription(this.name);
    },
    get metaDescription() {
      return makeMetaDescription(this.name);
    },
  },
  macys: {
    name: "Macy's",
    logoSmallWidth: 160,
    logoSmall: require('../assets/images/logos/macys-small.png'),
    logoSmall2x: require('../assets/images/logos/macys-small_2x.png'),
    logoLargeWidth: 450,
    logoLarge: require('../assets/images/logos/macys-large.png'),
    logoLarge2x: require('../assets/images/logos/macys-large_2x.png'),
    logoSquareWidth: 120,
    logoSquare: require('../assets/images/logos/macys-square.png'),
    logoSquare2x: require('../assets/images/logos/macys-square_2x.png'),
    background: require('../assets/images/header-photos/macys.jpg'),
    background2x: require('../assets/images/header-photos/macys_2x.jpg'),
    brandColor: '#000',
    get description() {
      return makeDescription(this.name);
    },
    get metaDescription() {
      return makeMetaDescription(this.name);
    },
  },
  target: {
    name: 'Target',
    logoSmallWidth: 160,
    logoSmall: require('../assets/images/logos/target-small.png'),
    logoSmall2x: require('../assets/images/logos/target-small_2x.png'),
    logoLargeWidth: 564,
    logoLarge: require('../assets/images/logos/target-large.png'),
    logoLarge2x: require('../assets/images/logos/target-large_2x.png'),
    logoSquareWidth: 120,
    logoSquare: require('../assets/images/logos/target-square.png'),
    logoSquare2x: require('../assets/images/logos/target-square_2x.png'),
    background: require('../assets/images/header-photos/target.jpg'),
    background2x: require('../assets/images/header-photos/target_2x.jpg'),
    brandColor: '#DA2033',
    get description() {
      return makeDescription(this.name);
    },
    get metaDescription() {
      return makeMetaDescription(this.name);
    },
  },
  'the-container-store': {
    name: 'The Container Store',
    logoSmallWidth: 160,
    logoSmall: require('../assets/images/logos/the-container-store-small.png'),
    logoSmall2x: require('../assets/images/logos/the-container-store-small_2x.png'),
    logoLargeWidth: 640,
    logoLarge: require('../assets/images/logos/the-container-store-large.png'),
    logoLarge2x: require('../assets/images/logos/the-container-store-large_2x.png'),
    logoSquareWidth: 120,
    logoSquare: require('../assets/images/logos/the-container-store-square.png'),
    logoSquare2x: require('../assets/images/logos/the-container-store-square_2x.png'),
    background: require('../assets/images/header-photos/the-container-store.jpg'),
    background2x: require('../assets/images/header-photos/the-container-store_2x.jpg'),
    brandColor: '#02509E',
    get description() {
      return makeDescription(this.name);
    },
    get metaDescription() {
      return makeMetaDescription(this.name);
    },
  },
};

export type StoreID = $Keys<typeof STORES>;
export default STORES;



// WEBPACK FOOTER //
// ./src/data/Stores.js